<template>
  <div>
    <!-- Grille de sections -->
    <div class="idb-grid">

      <!-- Informations personnelles -->
      <div class="idb-section">
        <p class="idb-section__title">Informations personnelles</p>
        <div class="idb-rows">
          <div class="idb-row">
            <span class="idb-row__label">Âge</span>
            <span class="idb-row__val">{{ safeUser.age }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Sexe</span>
            <span class="idb-row__val">{{ safeUser.sex ? $t(safeUser.sex) : '—' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Taille</span>
            <span class="idb-row__val">{{ safeUser.actualSize ? safeUser.actualSize + ' cm' : '—' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Poids actuel</span>
            <span class="idb-row__val">{{ safeUser.actualWeight ? safeUser.actualWeight + ' kg' : '—' }}</span>
          </div>
        </div>
      </div>

      <!-- Mode de vie -->
      <div class="idb-section">
        <p class="idb-section__title">Mode de vie</p>
        <div class="idb-rows">
          <div class="idb-row">
            <span class="idb-row__label">Métier</span>
            <span class="idb-row__val">{{ safeUser.job ? $t(safeUser.job) : '—' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Activité</span>
            <span class="idb-row__val">{{ safeUser.activityLevel ? $t(safeUser.activityLevel) : '—' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Pas / jour</span>
            <span class="idb-row__val">{{ safeUser.dailySteps ? $t(safeUser.dailySteps) : '—' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Sport / semaine</span>
            <span class="idb-row__val">{{ safeUser.weeklyWorkouts ?? '—' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Repas pris</span>
            <span class="idb-row__val">{{ safeUser.takenMeals.length ? safeUser.takenMeals.map(m => $t(m)).join(', ') : 'Aucun' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Magasins</span>
            <span class="idb-row__val">{{ safeUser.preferedGroceryStore.length ? safeUser.preferedGroceryStore.map(s => $t(s)).join(', ') : 'Aucun' }}</span>
          </div>
        </div>
      </div>

      <!-- Objectifs -->
      <div class="idb-section">
        <p class="idb-section__title">Objectifs</p>
        <div class="idb-rows">
          <div class="idb-row">
            <span class="idb-row__label">Poids visé</span>
            <span class="idb-row__val">{{ safeUser.targetWeight ? safeUser.targetWeight + ' kg' : '—' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Objectif principal</span>
            <span class="idb-row__val">{{ safeUser.weightObjective ? $t(safeUser.weightObjective) : '—' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Objectif secondaire</span>
            <span class="idb-row__val">{{ safeUser.secondaryObjective.length ? safeUser.secondaryObjective.map(o => $t(o)).join(', ') : 'Aucun' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Repas ciblés</span>
            <span class="idb-row__val">{{ safeUser.takenMealsObjectives.length ? safeUser.takenMealsObjectives.map(o => $t(o)).join(', ') : 'Aucun' }}</span>
          </div>
        </div>
      </div>

      <!-- Préférences alimentaires -->
      <div class="idb-section">
        <p class="idb-section__title">Préférences alimentaires</p>
        <div class="idb-rows">
          <div class="idb-row">
            <span class="idb-row__label">Allergies</span>
            <span class="idb-row__val">{{ safeUser.allergies.length ? safeUser.allergies.map(i => $t(i)).join(', ') : 'Aucune' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Intolérances</span>
            <span class="idb-row__val">{{ safeUser.intolerances.length ? safeUser.intolerances.map(i => $t(i)).join(', ') : 'Aucune' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Régime</span>
            <span class="idb-row__val">{{ safeUser.diet.length ? safeUser.diet.map(d => $t(d)).join(', ') : 'Aucun' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Viande</span>
            <span class="idb-row__val">{{ safeUser.meatConsumption ? $t(safeUser.meatConsumption) : '—' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Alcool</span>
            <span class="idb-row__val">{{ safeUser.alcoholConsumption ? $t(safeUser.alcoholConsumption) : '—' }}</span>
          </div>
          <div class="idb-row">
            <span class="idb-row__label">Conditions médicales</span>
            <span class="idb-row__val">{{ safeUser.medicalConditions.length ? safeUser.medicalConditions.map(c => $t(c)).join(', ') : 'Aucune' }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
  user: { type: Object, required: true },
});

const toArray = (v) => (Array.isArray(v) ? v : []);

const safeUser = computed(() => {
  const u = props.user || {};
  return {
    ...u,
    takenMeals: toArray(u.takenMeals),
    preferedGroceryStore: toArray(u.preferedGroceryStore),
    secondaryObjective: toArray(u.secondaryObjective),
    takenMealsObjectives: toArray(u.takenMealsObjectives),
    allergies: toArray(u.allergies),
    intolerances: toArray(u.intolerances),
    diet: toArray(u.diet),
    ingredientsToAvoid: toArray(u.ingredientsToAvoid),
    ingredientsToInclude: toArray(u.ingredientsToInclude),
    medicalConditions: toArray(u.medicalConditions),
  };
});
</script>

<style scoped>
/* Grille 2 colonnes */
.idb-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr;
}
@media (min-width: 640px) {
  .idb-grid { grid-template-columns: 1fr 1fr; }
}

/* Section */
.idb-section {
  background: rgb(var(--v-theme-tertiary));
  border-radius: 14px;
  border: 0.5px solid rgba(var(--v-theme-text), 0.08);
  padding: 14px 16px;
}
.idb-section__title {
  font-size: 12px;
  font-weight: 600;
  color: rgba(var(--v-theme-text), 0.4);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 10px;
}

/* Lignes */
.idb-rows { display: grid; gap: 5px; }
.idb-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  padding: 7px 10px;
  border-radius: 9px;
  background: rgba(var(--v-theme-text), 0.03);
}
.idb-row__label {
  font-size: 12px;
  color: rgba(var(--v-theme-text), 0.45);
  white-space: nowrap;
  flex-shrink: 0;
}
.idb-row__val {
  font-size: 12px;
  font-weight: 600;
  color: rgb(var(--v-theme-text));
  text-align: right;
}
</style>
